export const ScoringProvider = {
  HockeyTV: 0,
  Leaguestat: 7,
  Sportzcast: 8
}

export class SingularOverlay {
  constructor(obj) {
    this.name = obj && obj.name || "";
    this.cleanName = obj && obj.cleanName || this.name.substring(this.name.indexOf('-') + 1);
    this.active = obj && obj.active || false;
    this.overlayType = obj && obj.overlayType || "";
    this.availability = (obj && obj.availability && new SingularOverlayAvailability(obj.availability)) || new SingularOverlayAvailability();
    this.watermarkImage200x100 = (obj && obj.watermarkImage200x100 && new SingularOverlayKeyValue(obj.watermarkImage200x100)) || null;
    this.sponsorImage200x100 = (obj && obj.sponsorImage200x100 && new SingularOverlayKeyValue(obj.sponsorImage200x100)) || null;
    this.sponsorImage1328x100 = (obj && obj.sponsorImage1328x100 && new SingularOverlayKeyValue(obj.sponsorImage1328x100)) || null;
    this.sponsorImage1920x1080 = (obj && obj.sponsorImage1920x1080 && new SingularOverlayKeyValue(obj.sponsorImage1920x1080)) || null;
    this.allowPowerPlay = (obj && obj.allowPowerPlay && new SingularOverlayKeyValue(obj.allowPowerPlay)) || null;

    this.subLayers = {};
    if (obj && obj.subLayers) {
      Object.keys(obj.subLayers).forEach(key => {
        this.subLayers[key] = new SingularOverlayLayer({ name: key, subCompositions: obj.subLayers[key].subCompositions });
      });
    }
  }

  AvailableForScoring(scoringProviderId, isAdmin = false) {
    if (this.availability.hidden && !isAdmin) {
      return false;
    } else if (scoringProviderId == ScoringProvider.HockeyTV && this.availability.hockeyTVScoring) {
      return true
    } else if (scoringProviderId == ScoringProvider.Leaguestat && this.availability.leaguestatScoring) {
      return true
    } else if (scoringProviderId == ScoringProvider.Sportzcast && this.availability.sportzcastScoring) {
      return true
    } else {
      return false
    }
  }
}

export class SingularOverlayAvailability {
  constructor(obj) {
    this.hidden = (obj && obj.hidden) || false;
    this.locked = (obj && obj.locked) || false;
    this.hockeyTVScoring = (obj && obj.hockeyTVScoring) || false;
    this.leaguestatScoring = (obj && obj.leaguestatScoring) || false;
    this.sportzcastScoring = (obj && obj.sportzcastScoring) || false;
  }
}

export class SingularOverlayKeyValue {
  constructor(obj) {
    this.key = (obj && obj.key) || "";
    this.value = (obj && obj.value) || "";
  }
}

export class SingularOverlayLayer {
  constructor(obj) {
    this.name = obj && obj.name || "";
    this.cleanName = obj && obj.cleanName || this.name.substring(this.name.indexOf('-') + 1);

    this.subCompositions = {};
    if (obj && obj.subCompositions) {
      Object.keys(obj.subCompositions).forEach(key => {
        this.subCompositions[key] = new SingularOverlay(obj.subCompositions[key]);
      });
    }
  }

  HasAvailableOverlaysForScoring(scoringProviderId, isAdmin = false) {
    for (const key in this.subCompositions) {
      if (this.subCompositions[key].AvailableForScoring(scoringProviderId, isAdmin)) {
        return true;
      }
    }

    return false;
  }
}

angular.module('singularOverlaysFirebaseService', [])
  .factory('singularOverlaysFirebaseService',
    ['$http', 'ADMIN_API_URL', '$q', function ($http, ADMIN_API_URL, $q) {
      let databaseRef;
      let tokensByGame = {};
      let singularOverlaysCallbacks = {};
      let userInfo = null;
      let os = null;
      let browser = null;

      let getFbToken = function (gameId) {
        let deferred = $q.defer();

        if (!tokensByGame[gameId]) {
          const queryUrl = ADMIN_API_URL + "/broadcastManager/fbjwt/" + gameId;

          $http.get(queryUrl).then(function (response) {
            tokensByGame[gameId] = response.data.jwt;
            deferred.resolve();
          }, error => {
            deferred.reject();
          });
        }
        else {
          deferred.resolve();
        }

        return deferred.promise;
      };

      let init = function (fbDatabase, fbApiKey, userData, gameId) {
        let deferred = $q.defer();

        // Set info for logging
        userInfo = userData;
        os = window.navigator.platform;
        browser = window.navigator.userAgent;

        setTimeout(_ => {
          firebase.initializeApp({
            apiKey: fbApiKey,
            databaseURL: fbDatabase
          });
        }, 0);

        getFbToken(gameId).then(_ => {
          // Existing and future Auth states are now persisted in the current session
          // only. Closing the window would clear any existing state even if a user
          // forgets to sign out. New sign-in will be persisted with session persistence.
          firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION).then(function () {
            // Once I have the 'token', the clientside JS authenticates here...
            return firebase.auth().signInWithCustomToken(tokensByGame[gameId]).then(function () {
              databaseRef = firebase.database().ref();
              deferred.resolve();
            }).catch(function (error) {
              // Handle Errors here.
              let errorCode = error.code;
              let errorMessage = error.message;
              console.warn("ERROR: Firebase failed to authenticate", errorCode, errorMessage);
            });
          }).catch(function (error) {
            // Handle Errors here.
            let errorCode = error.code;
            let errorMessage = error.message;
            console.warn("ERROR: Firebase failed to authenticate", errorCode, errorMessage);
          });
        });

        return deferred.promise;
      };

      let logUserAction = function (gameId, action, method) {
        let data = {
          action: action,
          method: method,
          timestamp: Date.now(),
          userInfo: {
            userId: userInfo.iuserid,
            firstName: userInfo.first_name,
            lastName: userInfo.last_name,
            email: userInfo.login_name,
            os: os,
            browser: browser,
          }
        };

        let fbPath = "game/" + gameId + "/useractions";
        let useractionsRef = databaseRef.child(fbPath);

        useractionsRef.push(data).catch(error => {
          console.warn(error.message);
        });
      };

      let addToSingularOverlaysCallbacks = function (gameId, audioId, listenerCallback) {
        let gameUid = getGameLookupString(gameId, audioId);

        if (!singularOverlaysCallbacks[gameUid]) {
          singularOverlaysCallbacks[gameUid] = {
            listenerCallbacks: []
          };
        }

        singularOverlaysCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
      };

      let getGameLookupString = function (gameId, audioId) {
        if (!gameId) {
          console.log("ERROR: svfFb::createGameUid saw an invalid gameId - ", gameId);
          return undefined;
        }
        if (!audioId) {
          console.log("ERROR: svfFb::createGameUid saw an invalid langId - ", langId);
          return undefined;
        }

        return gameId + '-' + audioId;
      };

      let updateSingularOverlays = function (gameId, audioId, data) {
        let fbPath = "game/" + gameId + "/" + audioId + "/overlays";
        let overlaysRef = databaseRef.child(fbPath);

        overlaysRef.update(data).catch(error => {
          console.warn(error.message);
        });
      };

      let singularOverlaysCallbacksEmpty = function (gameId, audioId) {
        if (!gameId) {
          console.error("ERROR: svfFb::singularOverlaysCallbacksEmpty got an invalid gameId param - ", gameId);
        }
        if (!audioId) {
          console.error("ERROR: svfFb::singularOverlaysCallbacksEmpty got an invalid audioId param - ", audioId);
        }

        if (!singularOverlaysCallbacks[getGameLookupString(gameId, audioId)]) return true;

        if (!singularOverlaysCallbacks[getGameLookupString(gameId, audioId)].listenerCallbacks) return true;

        if (!singularOverlaysCallbacks[getGameLookupString(gameId, audioId)].listenerCallbacks.length) return true;

        return false;
      };

      let handleSingularOverlaysUpdate = function (snapshot) {
        const splitUrl = snapshot.ref.path.toString().split("/");
        const gameId = parseInt(splitUrl[2]);
        const audioId = parseInt(splitUrl[3]);
        const snapshotVal = snapshot.val();

        if (snapshotVal != null) {
          let overlayLayers = {}
          if (snapshotVal.singularState) {
            Object.keys(snapshotVal.singularState).forEach(key => {
              overlayLayers[key] = new SingularOverlayLayer({ name: key, subCompositions: snapshotVal.singularState[key].subCompositions });
            });
          }

          snapshotVal.gameId = gameId;
          snapshotVal.audioId = audioId;
          snapshotVal.singularState = overlayLayers;
        }

        singularOverlaysCallbacks[getGameLookupString(gameId, audioId)].overlayData = snapshotVal;

        notifySingularOverlaysListeners(gameId, audioId);
      };

      let notifySingularOverlaysListeners = function (gameId, audioId) {
        if (!singularOverlaysCallbacksEmpty(gameId, audioId)) {
          angular.forEach(singularOverlaysCallbacks[getGameLookupString(gameId, audioId)].listenerCallbacks, function (listenerCallback) {
            listenerCallback(singularOverlaysCallbacks[getGameLookupString(gameId, audioId)].overlayData);
          });
        }
      };

      let removeFromSingularOverlaysCallbacks = function (gameId, audioId, listenerCallback) {
        let gameUid = getGameLookupString(gameId, audioId);

        if (!singularOverlaysCallbacks[gameUid]) {
          console.log("ERROR: removeFromSingularOverlaysCallbacks called on callback that is not in our collection of callbacks (place 1)", singularOverlaysCallbacksEmpty, gameUid);
          return;
        }

        if (!singularOverlaysCallbacks[gameUid].listenerCallbacks) {
          console.log("ERROR: removeFromSingularOverlaysCallbacks called on callback that is not in our collection of callbacks (place 2)", singularOverlaysCallbacksEmpty, gameUid);
          return;
        }

        if (!singularOverlaysCallbacks[gameUid].listenerCallbacks.length) {
          console.log("ERROR: removeFromSingularOverlaysCallbacks called on callback that is not in our collection of callbacks (place 3)", singularOverlaysCallbacksEmpty, gameUid);
          return;
        }

        for (let i = 0; i < singularOverlaysCallbacks[gameUid].listenerCallbacks.length; i++) {
          if (singularOverlaysCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
            singularOverlaysCallbacks[gameUid].listenerCallbacks.splice(i, 1);
            return;
          }
        }

        console.log("ERROR: removeFromSingularOverlaysCallbacks called on callback that is not in our collection of callbacks (place 4)", singularOverlaysCallbacksEmpty, gameUid);
      };

      let subscribeToSingularOverlays = function (gameId, audioId, listenerCallback) {
        if (!gameId) console.log("ERROR: svfFb::subscribeToSingularOverlays saw an invalid gameId ", gameId);
        if (!audioId) console.log("ERROR: svfFb::subscribeToSingularOverlays saw an invalid audioId param ", audioId);
        if (!listenerCallback) console.log("ERROR: svfFb::subscribeToSingularOverlays saw an invalid listenerCallback param ", listenerCallback);

        let subscribeToFb = false;

        if (singularOverlaysCallbacksEmpty(gameId, audioId)) { // Determine if this is the first subscription.
          subscribeToFb = true;
        }

        addToSingularOverlaysCallbacks(gameId, audioId, listenerCallback);
        if (singularOverlaysCallbacksEmpty(gameId, audioId)) {
          console.log("ERROR: svfFb::subscribeToSingularOverlays saw an inconsistency where the callbacks are empty after adding to the callbacks", gameId, audioId, listenerCallback);
        }

        if (subscribeToFb) {
          let fbPath = "game/" + gameId + "/" + audioId + "/overlays";
          databaseRef.child(fbPath).on('value', handleSingularOverlaysUpdate);
        }

        return;
      };

      let unsubscribeFromSingularOverlays = function (gameId, audioId, listenerCallback) {

        removeFromSingularOverlaysCallbacks(gameId, audioId, listenerCallback)

        if (singularOverlaysCallbacksEmpty(gameId, audioId)) { // Close down the firebase listeners
          let fbPath = "game/" + gameId + "/" + audioId + "/overlays";
          databaseRef.child(fbPath).on('value', handleSingularOverlaysUpdate);
        }
      };

      return {
        init: init,
        subscribeToSingularOverlays: subscribeToSingularOverlays,
        unsubscribeFromSingularOverlays: unsubscribeFromSingularOverlays,
        updateSingularOverlays: updateSingularOverlays,
        logUserAction: logUserAction,
      };

    }]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/broadcastManager/singularOverlaysFirebaseService.js